import ClipboardShareButton from './ClipboardShareButton';

export default ClipboardShareButton;
